var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9938 6.11226C11.9938 5.62062 11.9529 5.26186 11.8646 4.88982H6.11963V7.1088H9.4918C9.42383 7.66025 9.0567 8.49072 8.24083 9.04877L8.2294 9.12306L10.0458 10.4982L10.1717 10.5104C11.3275 9.46735 11.9938 7.93263 11.9938 6.11226Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11957 11.9588C7.77165 11.9588 9.15859 11.4273 10.1716 10.5105L8.24077 9.04879C7.72408 9.40091 7.03058 9.64673 6.11957 9.64673C4.50146 9.64673 3.12812 8.60369 2.63856 7.16199L2.5668 7.16794L0.678021 8.59636L0.65332 8.66346C1.65953 10.6167 3.72637 11.9588 6.11957 11.9588Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63839 7.16199C2.50921 6.78994 2.43446 6.39129 2.43446 5.9794C2.43446 5.56746 2.50921 5.16885 2.63159 4.7968L2.62817 4.71756L0.715727 3.2662L0.653155 3.29529C0.238448 4.10584 0.000488281 5.01605 0.000488281 5.9794C0.000488281 6.94274 0.238448 7.85291 0.653155 8.66346L2.63839 7.16199Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11955 2.31202C7.26853 2.31202 8.04357 2.79701 8.48551 3.2023L10.2124 1.55464C9.15182 0.591298 7.77163 0 6.11955 0C3.72636 0 1.65953 1.34203 0.65332 3.29528L2.63176 4.79679C3.12811 3.3551 4.50145 2.31202 6.11955 2.31202Z",
    fill: "#EB4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c589a23b.svg";
export { ForwardRef as ReactComponent };